<template>
  <b-container style="">
    <b-row style="padding-top: 24px">
      <b-col md="4">
        <div style="padding-bottom: 16px">
          <b-form-input
            placeholder="Search hotel name.."
            v-model="searchText"
            @input="handleSearchChange"
          />
        </div>
        <div v-if="!loaded" class="text-center">
          <b-spinner />
        </div>

        <b-list-group style="overflow: auto; max-height: 1000px; margin-bottom: 16px">
          <b-list-group-item
            v-for="hotel in this.hotels"
            :key="hotel.id"
            button
            @click="handleSelect(hotel)"
            :active="selectedHotel.hotelId == hotel.hotelId"
            style="text-align: left"
          >
            {{
              hotel.name
                .split(" ")
                .map((s) => s.slice(0, 1).toUpperCase() + s.slice(1).toLowerCase())
                .join(" ")
            }}
          </b-list-group-item>
        </b-list-group>
      </b-col>

      <b-col v-if="this.selectedHotel.hotelId" style="overflow: auto">
        <div>
          <b-form-group>
            <label style="padding-bottom: 4px">Hotel Name</label>
            <b-form-input placeholder="Name" v-model="selectedHotel.name" disabled />
          </b-form-group>

          <b-form-group>
            <label style="padding-bottom: 4px">Amadeus ID</label>
            <b-form-input placeholder="Name" v-model="selectedHotel.hotelId" disabled />
          </b-form-group>

          <!-- <b-form-group>
            <label style="padding-bottom: 4px">City Code</label>
            <b-form-input
              placeholder="Name"
              v-model="selectedHotel.amadeusData.cityCode"
              disabled
            />
          </b-form-group> -->

          <b-form-checkbox
              v-model="selectedHotel.hasEVCharging"
              value="true"
              unchecked-value="false"
              style="margin-bottom: 16px"
            >
              Has EV Charging
            </b-form-checkbox>

          <b-form-group style="padding-top: 16px" v-if="selectedHotel.description">
            <label>Description</label>
            <b-form-textarea
              placeholder="Description"
              v-model="selectedHotel.description"
              style="height: 200px"
            />
          </b-form-group>

          <b-form-group>
            <img
              :src="selectedHotel ? selectedHotel.mediumUrl : ''"
              style="max-height: 600px; margin: 16px 0px 0px 0px"
            />

            <b-form-file
              style="margin-top: 16px"
              v-model="selectedHotelImage"
              placeholder=""
              @input="handleFileInput"
            ></b-form-file>
          </b-form-group>

          <div style="margin-top: 12px">
            <b-button
              v-if="selectedHotel.hotelId != null"
              variant="outline-primary"
              :to="`/hotel/${selectedHotel.name}/thumbnails`"
            >
              View Thumbnails</b-button
            >

            <b-button
              v-if="selectedHotel.hotelId != null"
              variant="outline-primary"
              :href="`/hotel/details_json?hotelId=${selectedHotel.hotelId}`"
            >
              Raw Details JSON</b-button
            >

            <b-button
              v-if="selectedHotel.hotelId != null"
              variant="outline-primary"
              :to="`/hotel/${selectedHotel.hotelId}/offers`"
            >
              Offers</b-button
            >

            <b-button
              variant="success"
              v-if="this.selectedHotel.hotelId == null"
              @click="handleSave"
            >
              Create
            </b-button>

            <b-button
              variant="primary"
              v-if="this.selectedHotel.hotelId != null"
              @click="handleSave"
            >
              Save
            </b-button>

            <b-button
              variant="danger"
              v-if="this.selectedHotel.hotelId != null"
              @click="handleDelete"
            >
              Delete
            </b-button>

            <b-button
              variant="light"
              v-if="this.selectedHotel.hotelId != null"
              @click="selectedHotel = {}"
            >
              Cancel
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      allHotels: [],
      hotels: [],
      selectedHotel: {},
      searchText: "",
      loaded: false,
      selectedHotelImage: [],
    };
  },
  mounted() {
    this.fetchHotels();
  },
  methods: {
    handleSearchChange(text) {
      console.log(this.searchText);
      if (text == "") {
        this.hotels = this.allHotels;
      } else {
        this.hotels = this.allHotels
          .filter((h) => h.name.toLowerCase().includes(this.searchText.toLowerCase()))
          .sort((a, b) => {
            if (a.name < b.name) return -1;
            return a.name > b.name ? 1 : 0;
          });
      }
    },
    async fetchHotels() {
      const response = await fetch("/hotels/list/");
      this.allHotels = await response.json();
      this.allHotels = this.allHotels.sort((a, b) => {
        if (a.name < b.name) return -1;
        return a.name > b.name ? 1 : 0;
      });
      this.hotels = this.allHotels;
      //   console.log(this.hotels);
      this.loaded = true;
    },
    handleSelect(hotel) {
      this.selectedHotel = hotel;
    },
    async handleFileInput() {
      var data = new FormData();
      data.append("photo", this.selectedHotelImage);

      const url = `/hotel/upload_image`;
      const response = await fetch(url, {
        method: "POST",
        headers: { ContentType: "multipart/form-data" },
        body: data,
      });

      const json = await response.json();
      this.selectedHotel.thumbnailUrl = json.thumbnailUrl;
      this.selectedHotel.mediumUrl = json.mediumUrl;
      this.selectedHotel.largeUrl = json.largeUrl;
    },
    async handleDelete() {
      try {
        const url = `/hotel/delete?id=${this.selectedHotel.hotelId}`;
        const response = await fetch(url, {
          method: "DELETE",
        });

        this.allHotels = this.allHotels.filter((h) => {
          return h.hotelId != this.selectedHotel.hotelId;
        });
        this.selectedHotel = {};
        this.searchText = "";
        this.hotels = this.allHotels;
      } catch (e) {
        console.log(e);
      }
    },
    async handleSave() {
      const url = `/hotel/update`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.selectedHotel),
      });

      this.fetchHotels();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/BrowseHotels.vue